import { default as _91_91slug_93_931UL3N3Zq3cMeta } from "/codebuild/output/src720366045/src/pages/article/[id]/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93SZHBd5YGQ5Meta } from "/codebuild/output/src720366045/src/pages/category/[id]/[[slug]].vue?macro=true";
import { default as indextzP0CfHvUkMeta } from "/codebuild/output/src720366045/src/pages/index.vue?macro=true";
import { default as indexsDlCs1so22Meta } from "/codebuild/output/src720366045/src/pages/search/index.vue?macro=true";
export default [
  {
    name: "article-id-slug",
    path: "/article/:id()/:slug?",
    component: () => import("/codebuild/output/src720366045/src/pages/article/[id]/[[slug]].vue")
  },
  {
    name: "category-id-slug",
    path: "/category/:id()/:slug?",
    component: () => import("/codebuild/output/src720366045/src/pages/category/[id]/[[slug]].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src720366045/src/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src720366045/src/pages/search/index.vue")
  }
]